// Company Information
export const COMPANY = {
  name: 'CSK Accounting',
  tagline: 'Expert Accounting Services in Edmonton',
  phone: '+1 (587) 778-7491',
  email: 'info@cskaccounting.ca',
  address: {
    street: '2809 Anton Wynd SW',
    city: 'Edmonton',
    province: 'AB',
    postalCode: 'T6W 4B1',
    country: 'Canada',
  },
  hours: {
    weekdays: '9:00 AM - 5:00 PM',
    saturday: 'By Appointment',
    sunday: 'Closed',
  },
  social: {
    linkedin: 'https://linkedin.com/company/csk-accounting',
    facebook: 'https://facebook.com/cskaccounting',
  },
} as const

// Navigation
export const NAV_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  {
    label: 'Services',
    href: '/services',
    children: [
      { label: 'Bookkeeping', href: '/services/bookkeeping' },
      { label: 'Payroll Services', href: '/services/payroll' },
      { label: 'Tax Preparation', href: '/services/tax-preparation' },
      { label: 'Financial Consulting', href: '/services/financial-consulting' },
      { label: 'Software Training', href: '/services/software-training' },
      { label: 'Tax Resolution', href: '/services/tax-resolution' },
      { label: 'Cloud Accounting', href: '/services/cloud-accounting' },
      { label: 'Part-Time CFO', href: '/services/part-time-cfo' },
    ],
  },
  {
    label: 'Industries',
    href: '/industries',
    children: [
      { label: 'Construction & Trades', href: '/industries/construction' },
      { label: 'Healthcare', href: '/industries/healthcare' },
      { label: 'E-commerce & Retail', href: '/industries/ecommerce' },
      { label: 'Non-Profits', href: '/industries/non-profits' },
      { label: 'Real Estate', href: '/industries/real-estate' },
    ],
  },
  { label: 'Resources', href: '/blog' },
  {
    label: 'Tools',
    href: '/tools',
    children: [
      { label: 'Personal Tax Calculator', href: '/tools/personal-tax-calculator' },
      { label: 'Corporate Tax Calculator', href: '/tools/corporate-tax-calculator' },
      { label: 'Tax Comparison Tool', href: '/tools/tax-comparison' },
      { label: 'GST/HST Calculator', href: '/tools/gst-hst-calculator' },
      { label: 'Payroll Calculator', href: '/tools/payroll-calculator' },
      { label: 'RRSP Calculator', href: '/tools/rrsp-calculator' },
      { label: 'View All Tools', href: '/tools' },
    ],
  },
  { label: 'Contact', href: '/contact' },
]

// Design tokens
export const DESIGN = {
  spacing: {
    section: 'py-16 md:py-24',
    sectionLarge: 'py-24 md:py-32',
    container: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
  },
  transition: {
    default: 'transition-all duration-300 ease-in-out',
    fast: 'transition-all duration-150 ease-in-out',
  },
} as const

// SEO defaults
export const SEO = {
  titleTemplate: '%s | CSK Accounting',
  defaultTitle: 'CSK Accounting | Edmonton Accounting & Tax Services',
  defaultDescription:
    'Professional accounting, bookkeeping, and tax services in Edmonton, Alberta. Serving construction, healthcare, e-commerce, non-profits, and real estate industries.',
  siteUrl: 'https://cskaccounting.ca',
  locale: 'en_CA',
  ogImage: '/og-default.png',
} as const
